import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchBeaconList(filter) {
  return request({
    url: '/api/beacons',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchBeacon(id, filter) {
  return request({
    url: '/api/beacons/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createBeacon(data) {
  return request({
    url: '/api/beacons',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateBeacon(id, data) {
  return request({
    url: '/api/beacons/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}




